<ng-container *ngIf="action$ | async"></ng-container>

<div *ngIf="data$ | async">
  <div class="flex flex-row space-x-2">
    <button mat-raised-button [color]="'accent'" (click)="openMaterialBaseDialog('+')">Добавить сверху</button>
    <button mat-raised-button [color]="'accent'" (click)="openMaterialBaseDialog('-')">Добавить снизу</button>
  </div>

  <table mat-table #table [dataSource]="countertop.outline.faceBanding" class="w-full">
    <ng-container matColumnDef="n">
      <th mat-header-cell *matHeaderCellDef class="pl-4 pr-2">#</th>
      <td mat-cell *matCellDef="let row" class="pr-2 pl-4">{{ row.order }}</td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Название</th>
      <td mat-cell *matCellDef="let row" class="text-sm pr-2">{{ row.material.name }}</td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Тип</th>
      <td mat-cell *matCellDef="let row" class="pr-2">
        <ng-container [ngSwitch]="row.material.type">
          <span *ngSwitchCase="0" i18n>Плитный</span>
          <span *ngSwitchCase="1" i18n>Погонный</span>
          <span *ngSwitchDefault></span>
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="thickness">
      <th mat-header-cell *matHeaderCellDef>Толщина</th>
      <td mat-cell *matCellDef="let row" class="pr-2">{{ row.material.thickness }} <span i18n>мм</span></td>
    </ng-container>
    <ng-container matColumnDef="plate">
      <th mat-header-cell *matHeaderCellDef class="w-5"></th>
      <td mat-cell *matCellDef="let row" class="w-5 pt-1">
        <mat-icon class="s-20" *ngIf="row.level > 0" ш18т-matTooltip matTooltip="Сверху"
          >vertical_align_bottom</mat-icon
        >
        <mat-icon class="s-20" *ngIf="row.level < 0" ш18т-matTooltip matTooltip="Снизу">vertical_align_top</mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef class="w-10 pr-4"></th>
      <td mat-cell *matCellDef="let row" class="w-10 pr-4">
        <button mat-icon-button (click)="deleteBand(row)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="['n', 'name', 'type', 'thickness', 'plate', 'delete']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['n', 'name', 'type', 'thickness', 'plate', 'delete']"></tr>
  </table>
</div>
